import React from 'react';
import './App.css';
import * as Sentry from '@sentry/browser';
import Routes from './routes';
import play from './assets/play.png';

Sentry.init({ dsn: "https://55b3b6a26692427690c86dba4b58d40e@sentry.io/1867137" });

function App() {

  return (
    <div className="container">
      <div className="content">
        <Routes />
      </div>
      <a href='https://play.google.com/store/apps/details?id=caiquecoelho.com.testeeneagrama'>
        <img className='photo-play' src={play} alt="Baixe o teste eneagrama na play store para Android!"
        />
      </a>
    </div>
  );
}

export default App;
